import { NATIVE_ADDRESS } from "@/constants/addresses";
import { STORAGE_KEYS, getStorageKey } from "@/libs/Storage";
import { useMemo } from "react";
import { useLocalStorage } from "usehooks-ts";
import { useAccount } from "@/hooks/useAccount";

export type Theme =
  | "darkbg"
  | "lightbg"
  | "cream"
  | "black"
  | "lavender"
  | "green"
  | "pink"
  | "orange"
  | "blue"
  | "lemon"
  | "dark";

export const ThemeOptions = [
  { theme: "darkbg", name: "Dark Background", color: "#262432" },
  { theme: "lightbg", name: "Light Background", color: "#d5d0e1" },
  { theme: "cream", name: "Cream", color: "#e2e5da" },
  { theme: "black", name: "Black", color: "#252627" },
  { theme: "lavender", name: "Lavender", color: "#d5d0e1" },
  { theme: "green", name: "Green", color: "#b4d3b9" },
  { theme: "pink", name: "Pink", color: "#ffcfdd" },
  { theme: "orange", name: "Orange", color: "#ff6952" },
  { theme: "blue", name: "Blue", color: "#c6def1" },
  { theme: "lemon", name: "Lemon", color: "#d7f78a" },
  { theme: "dark", name: "Dark", color: "#262432" },
];

const initThemeSettingStorageContext: Theme = "lightbg";

export const useThemeSettingStorage = () => {
  const { address, chain } = useAccount();

  const storageKey = useMemo(
    () =>
      getStorageKey(chain?.id, address ?? NATIVE_ADDRESS, STORAGE_KEYS.THEME),
    [address, chain?.id]
  );

  const [theme, setTheme] = useLocalStorage<Theme>(
    storageKey,
    initThemeSettingStorageContext
  );

  return {
    theme,
    setTheme,
    ThemeOptions,
  };
};
